module.exports = __webpack_public_path__ + "img/SMS80301-L-min.c34a2105.png";